import React from 'react'
import { handleKeyDown } from '../../common/common'

function MarginAllowancesTable(props) {
    const {
        calculatorData = {},
        setCalculatorData = () => { },
        disableEdit = false
    } = props

    const { portOperation = [] } = calculatorData || {}

    const onChangeMarginAllowance = (e, index) => {
        const { name = "", value = "" } = e.target
        let updatedPortOperation = [...portOperation]
        if (name === "dwf") {
            updatedPortOperation[index].dwf = Number(value)
        } else {
            updatedPortOperation[index].cargoDetails[name] = Number(value)
        }
        setCalculatorData({
            ...calculatorData,
            portOperation: updatedPortOperation
        })
    }

    const thClass = "px-1.5 py-1 text-left border-r border-b border-[#cbd5e1] text-[11px] font-medium !text-[#000000] [webkit-text-fill-color:#000000] opacity-100 bg-[#e2e8f0] capitalize tracking-normal align-middle !font-medium whitespace-nowrap leading-[1.15]";
    const tdClass = "border-r border-b border-[#cbd5e1] px-1.5 py-0 h-[19px] leading-[19px] align-middle bg-[#ffffff] text-[11px] font-medium !text-[#000000] [webkit-text-fill-color:#000000] opacity-100 !font-medium truncate";
    const tdInputClass = "border-r border-b border-[#cbd5e1] p-0 h-[19px] align-middle bg-[#ffffd6] focus-within:bg-[#ffffff]";
    const tableInputClass = "w-full h-[19px] leading-[19px] text-[11px] px-1.5 py-0 m-0 box-border block outline-none focus:bg-[#ffffff] focus:outline focus:outline-[1.5px] focus:outline-[#d97706] focus:-outline-offset-[1.5px] focus:ring-0 bg-[#ffffd6] !text-[#000000] [webkit-text-fill-color:#000000] opacity-100 border-none font-medium text-left !font-medium";

    return (
        <div className="w-full bg-[#ffffff] flex flex-col font-sans">
            {disableEdit ? <h1 className="text-[12px] font-medium text-[#1e293b] mb-1">Margin Allowances Table</h1> : null}
            <div className="overflow-x-auto scroll-thin border-t border-l border-[#cbd5e1] rounded-none">
                <table className="w-full min-w-[520px] text-left border-collapse" style={{ tableLayout: "fixed" }}>
                    <thead>
                        <tr className="bg-[#e2e8f0] text-[#000000] text-[11px]">
                            <th className={thClass} style={{ width: "17%" }}>Operation</th>
                            <th className={thClass} style={{ width: "29%" }}>Port</th>
                            <th className={thClass} style={{ width: "13%" }}>Dwf<br />(%)</th>
                            <th className={thClass} style={{ width: "14%" }}>Speed Factor<br />(%)</th>
                            <th className={thClass} style={{ width: "14%" }}>Speed Reduce<br />(Knots)</th>
                            <th className={thClass} style={{ width: "13%" }}>BnkrFactor<br />(%)</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                        {portOperation.map((operations, index) => {
                            const { operation = '', port = '', cargoDetails = {}, dwf = 0 } = operations
                            const { bnkrFactor = 0, speedReduce = 0, speedFactor = 0 } = cargoDetails || {}

                            return (
                                <tr key={index} className="hover:bg-[#f8fafc] transition-colors">
                                    <td className={tdClass} title={operation}>{operation}</td>
                                    <td className={tdClass} title={port}>{port}</td>
                                    <td className={tdInputClass}>
                                        <input
                                            onKeyDown={handleKeyDown}
                                            type="number"
                                            className={tableInputClass}
                                            value={dwf}
                                            name="dwf"
                                            onChange={(e) => onChangeMarginAllowance(e, index)}
                                        />
                                    </td>
                                    <td className={tdInputClass}>
                                        <input
                                            onKeyDown={handleKeyDown}
                                            type="number"
                                            className={tableInputClass}
                                            value={speedFactor}
                                            name="speedFactor"
                                            onChange={(e) => onChangeMarginAllowance(e, index)}
                                        />
                                    </td>
                                    <td className={tdInputClass}>
                                        <input
                                            onKeyDown={handleKeyDown}
                                            type="number"
                                            className={tableInputClass}
                                            value={speedReduce}
                                            name="speedReduce"
                                            onChange={(e) => onChangeMarginAllowance(e, index)}
                                        />
                                    </td>
                                    <td className={tdInputClass}>
                                        <input
                                            onKeyDown={handleKeyDown}
                                            type="number"
                                            className={tableInputClass}
                                            value={bnkrFactor}
                                            name="bnkrFactor"
                                            onChange={(e) => onChangeMarginAllowance(e, index)}
                                        />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default MarginAllowancesTable
